"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PlayerCore = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _padStart2 = _interopRequireDefault(require("lodash/padStart"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _style = _interopRequireDefault(require("./style.css"));
var _reactRedux = require("react-redux");
var _allElements = _interopRequireDefault(require("../../../allElements.js"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _ProgressBar = _interopRequireDefault(require("./ProgressBar.js"));
var _player = require("../../../reducers/player.js");
var _player2 = require("../../../selectors/player.js");
var _builder = require("../../../selectors/builder.js");
var _allTemplates = require("../../../allTemplates.js");
var _helpers = require("./helpers.js");
var _helpers2 = require("../../../other/helpers.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _randomstring = _interopRequireDefault(require("randomstring"));
var _preload = _interopRequireDefault(require("./preload.js"));
var _context9 = require("../../../context.js");
var _withContext = _interopRequireDefault(require("../../../other/withContext.js"));
var _ensureGlobalClick = _interopRequireDefault(require("../../../other/ensureGlobalClick.js"));
var _notification = _interopRequireDefault(require("cccisd-icons/notification2"));
var _deepObjectDiff = require("deep-object-diff");
var _cccisdSound = require("cccisd-sound");
var _useFullscreen2 = _interopRequireDefault(require("./useFullscreen.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var confirmSkipping = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(message) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            (0, _cccisdConfirm["default"])({
              message: 'Are you sure?',
              description: message
            }).then(function () {
              resolve(true);
            }).fail(function () {
              resolve(false);
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function confirmSkipping(_x) {
    return _ref.apply(this, arguments);
  };
}();
var PlayerCore = exports.PlayerCore = /*#__PURE__*/function (_React$Component) {
  _inherits(PlayerCore, _React$Component);
  function PlayerCore(_props) {
    var _this;
    _classCallCheck(this, PlayerCore);
    _this = _callSuper(this, PlayerCore, [_props]);
    _defineProperty(_assertThisInitialized(_this), "timeout", null);
    _defineProperty(_assertThisInitialized(_this), "rejectAllActions", void 0);
    _defineProperty(_assertThisInitialized(_this), "autoplay", true);
    _defineProperty(_assertThisInitialized(_this), "stopPlayingActions", function (event) {
      if (_this.props.accommodations.blockUserInteractions) {
        return;
      }

      // Cancel the action sequence
      if (_this.rejectAllActions) {
        _this.rejectAllActions('The user interraction happened');
      }

      // Cancel all playing actions
      _this.props.playingAction.forEach(function (item) {
        item.stop();
        _this.props.unsetPlayingAction(item.id);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setupManualActions", function () {
      // remove all playing actions
      _this.props.playingAction.forEach(function (item) {
        item.stop();
        _this.props.unsetPlayingAction(item.id);
      });
      _this.props.resetActions();
      _this.autoplay = false;
      _this.timeout = setTimeout(_this._runActions, 200);
    });
    _defineProperty(_assertThisInitialized(_this), "adjustAudioForGames", function () {
      if (window.createjs && window.createjs.Sound) {
        window.createjs.Sound.muted = !_this.props.enableAudio;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_doesTemplateControlActions", function () {
      var customTemplate = (0, _allTemplates.getTemplate)('players', 'flow', _this.props.playerTemplate.playerTemplate);
      if (customTemplate && customTemplate.controlActions) {
        return true;
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "_getPubSub", function () {
      var props = _this.props;
      return {
        publish: function publish(event, data) {
          (0, _filter2["default"])(props.subscriptions, {
            event: event
          }).forEach(function (item) {
            return item.callback(data);
          });
        },
        subscribe: function subscribe(event, callback) {
          var token = _randomstring["default"].generate(10);
          props.addSubscription({
            token: token,
            event: event,
            callback: callback
          });
          return token;
        },
        unsubscribe: function unsubscribe(token) {
          props.deleteSubscription(token);
        }
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_setPageStartedTime", function () {
      _this.props.setPageStartedTime((0, _helpers2.getCurrentGmtTime)());
    });
    _defineProperty(_assertThisInitialized(_this), "_runActions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var $this;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            // Prevent "late" actions to break action flow
            _this.timeout = null;
            $this = _assertThisInitialized(_this);
            _context4.prev = 2;
            _context4.next = 5;
            return new Promise( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
                var continuePlaying, actions, i;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      continuePlaying = true;
                      _this.rejectAllActions = function () {
                        continuePlaying = false;
                        reject();
                      };

                      // Handle actions if we have ones
                      if (!(_this.props.actions.length > 0)) {
                        _context3.next = 26;
                        break;
                      }
                      actions = (0, _sortBy2["default"])(_this.props.actions, ['position']).map(function (action) {
                        return _objectSpread(_objectSpread({}, action), {}, {
                          play: function play() {
                            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                              var name, result;
                              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                                while (1) switch (_context2.prev = _context2.next) {
                                  case 0:
                                    // Stop previous actions
                                    $this.props.playingAction.forEach(function (item) {
                                      item.stop();
                                      $this.props.unsetPlayingAction(item.id);
                                    });
                                    name = action.name || "unnamed".concat(action.position);
                                    $this.props.setPlayingAction({
                                      id: action.id,
                                      name: name,
                                      stop: action.stop
                                    });
                                    _context2.next = 5;
                                    return action.play();
                                  case 5:
                                    result = _context2.sent;
                                    $this.props.unsetPlayingAction(action.id);
                                    return _context2.abrupt("return", result);
                                  case 8:
                                  case "end":
                                    return _context2.stop();
                                }
                              }, _callee2);
                            }))();
                          }
                        });
                      });
                      _this._getPubSub().publish('ACTIONS_READY', actions);
                      if (!_this._doesTemplateControlActions()) {
                        _context3.next = 8;
                        break;
                      }
                      _this.setState({
                        disableUserInput: false
                      });
                      return _context3.abrupt("return");
                    case 8:
                      if (_this.props.isPageVisited) {
                        _context3.next = 26;
                        break;
                      }
                      if (_this.autoplay) {
                        actions = actions.filter(function (item) {
                          return item.autoplay;
                        });
                      }
                      if (!(actions.length > 0)) {
                        _context3.next = 26;
                        break;
                      }
                      _context3.next = 13;
                      return new Promise(function (resolve1) {
                        return setTimeout(resolve1, 500);
                      });
                    case 13:
                      _context3.prev = 13;
                      i = 0;
                    case 15:
                      if (!(i < actions.length)) {
                        _context3.next = 22;
                        break;
                      }
                      if (!continuePlaying) {
                        _context3.next = 19;
                        break;
                      }
                      _context3.next = 19;
                      return actions[i].play();
                    case 19:
                      i++;
                      _context3.next = 15;
                      break;
                    case 22:
                      _context3.next = 26;
                      break;
                    case 24:
                      _context3.prev = 24;
                      _context3.t0 = _context3["catch"](13);
                    case 26:
                      resolve();
                    case 27:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3, null, [[13, 24]]);
              }));
              return function (_x2, _x3) {
                return _ref3.apply(this, arguments);
              };
            }());
          case 5:
            _context4.next = 9;
            break;
          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](2);
          case 9:
            _this.rejectAllActions = null;
            if (_this.mounted) {
              _this.setState({
                disableUserInput: false
              });
            }
            _this._getPubSub().publish('ACTIONS_DONE');
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 7]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "_getElementType", function (element) {
      var elementType = (0, _find2["default"])(_allElements["default"], {
        code: element.type
      });
      return elementType || {};
    });
    _defineProperty(_assertThisInitialized(_this), "_onUpdate", function (elementId, answer) {
      _this.props.updateAnswer({
        elementId: elementId,
        answer: answer
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onError", function (elementId) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Error';
      _this.props.setAnswerError({
        elementId: elementId,
        message: message
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getPerPage", function () {
      return _this.props.settings.showOneElementPerPage ? 1 : 9999;
    });
    _defineProperty(_assertThisInitialized(_this), "_validate", function () {
      _this.props.setValidationErrors();
    });
    _defineProperty(_assertThisInitialized(_this), "scrollToTop", function () {
      _this.flowTop.scrollIntoView();
    });
    _defineProperty(_assertThisInitialized(_this), "_goToNextPage", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
        var _this$props, isPreviewMode, isPresenterMode, onComplete, answers, errors, isSkipped, playerSettings, result, canProceed, promises, message;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              e && e.preventDefault();
              _this$props = _this.props, isPreviewMode = _this$props.isPreviewMode, isPresenterMode = _this$props.isPresenterMode, onComplete = _this$props.onComplete, answers = _this$props.answers, errors = _this$props.errors, isSkipped = _this$props.isSkipped;
              if (!isSkipped) {
                _context6.next = 11;
                break;
              }
              playerSettings = _this._getActualPlayerSettings();
              if (!playerSettings.askIfSkipped) {
                _context6.next = 11;
                break;
              }
              _context6.next = 7;
              return confirmSkipping(playerSettings.skippedConfirmationText);
            case 7:
              result = _context6.sent;
              if (result) {
                _context6.next = 11;
                break;
              }
              _this.setState({
                showSkippedQuestions: true
              });
              return _context6.abrupt("return");
            case 11:
              if (_this.state.showSkippedQuestions) {
                _this.setState({
                  showSkippedQuestions: false
                });
              }
              canProceed = true;
              if (isPresenterMode) {
                _context6.next = 27;
                break;
              }
              // Run onBeforeNextPage for all page elements
              promises = _this.getAdjustedPageElements().filter(function (element) {
                return element.elementType.onBeforeNextPage;
              }).map(function (element) {
                return element.elementType.onBeforeNextPage({
                  settings: element.adjustedSettings,
                  answer: answers[element.id],
                  error: errors[element.id],
                  children: _this._getChildren(element.id)
                });
              });
              _context6.prev = 15;
              _context6.next = 18;
              return Promise.all(promises);
            case 18:
              _context6.next = 27;
              break;
            case 20:
              _context6.prev = 20;
              _context6.t0 = _context6["catch"](15);
              message = Array.isArray(_context6.t0) ? _context6.t0.join('\n') : _context6.t0;
              clearTimeout(_this.onBeforeNextPageErrorTimeout);
              _this.setState({
                onBeforeNextPageError: message
              });
              _this.onBeforeNextPageErrorTimeout = setTimeout(function () {
                _this.setState({
                  onBeforeNextPageError: null
                });
              }, 3000);
              canProceed = false;
            case 27:
              if (canProceed) {
                _this._debounce('nextPage', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this.props.saveAndGoToNextPage({
                          isPreviewMode: isPreviewMode,
                          onComplete: onComplete
                        });
                      case 2:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                })));
              }
            case 28:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[15, 20]]);
      }));
      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    // don't run function twice if previous call hasn't done yet
    _defineProperty(_assertThisInitialized(_this), "_debounce", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(name, fn) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!_this[name]) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              _this[name] = true;
              _context7.next = 5;
              return fn();
            case 5:
              _this[name] = false;
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x5, _x6) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_correctPreviousAnswers", function (e) {
      e && e.preventDefault();
      _this.props.switchFeedbackMode(false);
    });
    _defineProperty(_assertThisInitialized(_this), "_goToPrevPage", function (e) {
      e && e.preventDefault();
      var isPreviewMode = _this.props.isPreviewMode;
      if (!_this.props.isEmptyPageHistory) {
        _this._debounce('prevPage', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this.props.saveAndGoToPrevPage({
                  isPreviewMode: isPreviewMode
                });
              case 2:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        })));
      } else {
        _this.props.goBack();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_goToComponent", function (id) {
      _this.props.saveAndGoToComponent({
        componentId: id,
        isPreviewMode: _this.props.isPreviewMode
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_saveStateAndMetrics", function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _this.props.saveStateAndMetrics(_objectSpread({
        isPreviewMode: _this.props.isPreviewMode
      }, params));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderProgressBar", function (playerSettings) {
      // If it's the only page then don't show progress bar
      if (_this.props.isFirstPage && _this.props.isLastPage || _this.props.isCompleteMessage) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_ProgressBar["default"], {
        playerSettings: playerSettings,
        progressBarPercent: _this.props.progressBarPercent,
        segmentedProgressBar: _this.props.segmentedProgressBar,
        goToComponent: _this._goToComponent
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_registerAction", function (elementPosition) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 999;
      var action = arguments.length > 2 ? arguments[2] : undefined;
      var name;
      if ((0, _isObject2["default"])(index)) {
        name = index.name;
        index = index.position || 999;
      }
      var position = (0, _padStart2["default"])(elementPosition, '6', '0') + (0, _padStart2["default"])(index, '6', '0');
      _this.props.registerAction(_objectSpread(_objectSpread({}, action), {}, {
        position: position,
        name: name
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getChildren", function (elementId) {
      var _this$props2 = _this.props,
        list = _this$props2.list,
        progress = _this$props2.progress;
      if (!list[elementId].children) {
        return [];
      }
      var children = list[elementId].children.map(function (child) {
        var result = (0, _cloneDeep2["default"])(list[child]);
        if (progress[child]) {
          result.progress = progress[child];
        }
        return result;
      });
      return children;
    });
    _defineProperty(_assertThisInitialized(_this), "preventSubmittingForm", function (e) {
      e.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "getAdjustedPageElements", function () {
      var _this$props3 = _this.props,
        isPreviewMode = _this$props3.isPreviewMode,
        defaultValueVariables = _this$props3.defaultValueVariables,
        answers = _this$props3.answers;
      return _this.props.pageElements.map(function (element) {
        var elementType = _this._getElementType(element);
        var ElementPlayer = elementType.player;
        var initialValues = {
          value: answers[element.id] !== undefined ? answers[element.id] : elementType.getPlayerInitialValue(element.settings, isPreviewMode ? undefined : defaultValueVariables)
        };
        var adjustedSettings = _objectSpread(_objectSpread({}, elementType.builderInitialValues), element.settings);
        return _objectSpread(_objectSpread({}, element), {}, {
          elementType: elementType,
          adjustedSettings: adjustedSettings,
          ElementPlayer: ElementPlayer,
          initialValues: initialValues
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderElements", function (playerTemplateProps) {
      if (_this.props.isCompleteMessage) {
        return null;
      }
      var _this$props4 = _this.props,
        isFeedbackMode = _this$props4.isFeedbackMode,
        settings = _this$props4.settings,
        accommodations = _this$props4.accommodations,
        allQuestionStartNumbers = _this$props4.allQuestionStartNumbers,
        isPreviewMode = _this$props4.isPreviewMode,
        skippedElements = _this$props4.skippedElements;
      return _this.getAdjustedPageElements().map(function (element, index) {
        var _this$props$progress$;
        var template;
        var templateExtraProps;
        var customTemplate = (0, _allTemplates.getTemplate)('components', element.type, element.settings.template);
        if (customTemplate) {
          template = customTemplate.component;
          templateExtraProps = {
            templateSettings: _objectSpread(_objectSpread({}, customTemplate.defaultSettings), element.settings.templateSettings),
            storage: _this.props.storage,
            setToStorage: _this.props.setToStorage,
            pubSub: _this._getPubSub(),
            pawnId: _this.props.pawnId,
            pawnHash: _this.props.pawnHash,
            goToNextPage: _this._goToNextPage
          };
        }
        var elementAccommodations = _this._getAdjustedAccommodations(element.settings.overrideAccommodations ? element.settings.accommodations : accommodations);
        if ((_this$props$progress$ = _this.props.progress[element.id]) !== null && _this$props$progress$ !== void 0 && _this$props$progress$.finishedFirst) {
          elementAccommodations.masking = false;
        }
        var extraProps = {};
        if (settings.showQuestionNumbers && allQuestionStartNumbers[element.id]) {
          extraProps.showQuestionNumbers = true;
          extraProps.startQuestionNumber = allQuestionStartNumbers[element.id];
        }
        var elementStyle = (0, _get2["default"])(playerTemplateProps, 'playerTemplateSettings.elementStyle');
        var ElementPlayer = element.ElementPlayer,
          adjustedSettings = element.adjustedSettings,
          initialValues = element.initialValues,
          elementType = element.elementType;

        // If element has hasFeedback function which returns feedback then element is responsible to disable user interaction itself
        // For example, element can leave user interaction for feedback text
        var disableUserInteractions = isFeedbackMode && (!elementType.hasFeedback || !elementType.hasFeedback({
          settings: adjustedSettings,
          answer: initialValues.value
        }));
        return /*#__PURE__*/_react["default"].createElement("form", {
          key: element.id,
          className: (0, _classnames3["default"])(_style["default"].element, _style["default"][elementStyle], _defineProperty({}, _style["default"].disableUserInteractions, disableUserInteractions)),
          onSubmit: _this.preventSubmittingForm
        }, /*#__PURE__*/_react["default"].createElement(ElementPlayer, _extends({
          form: 'player' + element.id + (_this.props.enableAudio ? '_audio' : ''),
          key: element.id,
          flowId: _this.props.flowId,
          responseSet: _this.props.responseSet,
          componentId: element.id,
          settings: adjustedSettings,
          initialValues: initialValues,
          isValidating: _this.props.showValidationErrors,
          isFeedbackMode: _this.props.isFeedbackMode,
          onUpdate: _this._onUpdate.bind(_assertThisInitialized(_this), element.id),
          onError: _this._onError.bind(_assertThisInitialized(_this), element.id),
          showRequiredState: settings.showRequiredState,
          template: template,
          templateExtraProps: templateExtraProps,
          registerAction: _this._registerAction.bind(_assertThisInitialized(_this), index + 1),
          parameters: _this.props.parameters,
          setParameters: _this.props.setParameters,
          playerTemplateProps: playerTemplateProps,
          accommodations: elementAccommodations,
          children: _this._getChildren(element.id),
          goToComponent: _this._goToComponent,
          saveStateAndMetrics: _this._saveStateAndMetrics,
          goToNextPage: _this._goToNextPage,
          storage: _this.props.storage,
          setToStorage: _this.props.setToStorage,
          pubSub: _this._getPubSub(),
          pawnId: _this.props.pawnId,
          pawnHash: _this.props.pawnHash,
          isSavingMetrics: !isPreviewMode,
          availableComponentTemplates: (0, _allTemplates.getTemplatesForGroup)('components'),
          dynamicUserLists: _this.props.dynamicUserLists,
          dynamicUserListsValues: _this.props.dynamicUserListsValues,
          showFeedback: isFeedbackMode && adjustedSettings.showAnswerFeedback,
          showCorrectnessFeedback: isFeedbackMode && adjustedSettings.showCorrectnessFeedback,
          setupManualActions: _this.setupManualActions
        }, extraProps)), _this.state.showSkippedQuestions && skippedElements.includes(element.id) ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].skipped + ' text-warning'
        }, /*#__PURE__*/_react["default"].createElement(_notification["default"], {
          spaceRight: true
        }), "Skipped") : null);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_showPrevButton", function () {
      return (!_this.props.isEmptyPageHistory || _this.props.pageFirstElementId === 0 && _this.props.goBack) && !_this.props.isCompleteMessage;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderPrevButton", function () {
      if (!_this._showPrevButton()) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-secondary btn-sm",
        onClick: _this._goToPrevPage
      }, "Prev");
    });
    _defineProperty(_assertThisInitialized(_this), "_showNextButton", function () {
      return !_this._showFeedbackButton() && !_this.props.isLastPage && !_this.props.isCompleteMessage;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderNextButton", function () {
      if (!_this._showNextButton()) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-secondary btn-sm",
        onClick: _this._goToNextPage
      }, "Next");
    });
    _defineProperty(_assertThisInitialized(_this), "_showCompleteButton", function () {
      return !_this._showFeedbackButton() && _this.props.isLastPage && !_this.props.isCompleteMessage;
    });
    _defineProperty(_assertThisInitialized(_this), "_showFeedbackButton", function () {
      return !_this.props.isFeedbackMode && _this.props.hasPageFeedback;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderCompleteButton", function () {
      if (!_this._showCompleteButton()) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-primary btn-sm",
        onClick: _this._goToNextPage
      }, "Complete");
    });
    _defineProperty(_assertThisInitialized(_this), "_renderCompleteMessage", function () {
      if (!_this.props.isCompleteMessage) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: "<p>Thank you! The survey has been completed.</p>"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getAdjustedAccommodations", function (accommodations) {
      if (_this.props.enableAudio) {
        return _objectSpread({}, accommodations);
      }
      return _objectSpread(_objectSpread({}, accommodations), {}, {
        disableAudio: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getActualPlayerSettings", function () {
      var _this$props5 = _this.props,
        playerTemplate = _this$props5.playerTemplate,
        forcedContextPlayerSettings = _this$props5.forcedContextPlayerSettings,
        contextPlayerSettings = _this$props5.contextPlayerSettings;
      var customTemplate = (0, _allTemplates.getTemplate)('players', 'flow', playerTemplate.playerTemplate);
      if (!customTemplate) {
        throw new Error("There is no template \"".concat(playerTemplate.playerTemplate, "\""));
      }
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, customTemplate.defaultSettings), contextPlayerSettings), (0, _deepObjectDiff.updatedDiff)(customTemplate.defaultSettings, playerTemplate.playerTemplateSettings)), forcedContextPlayerSettings);
    });
    _this.state = {
      // Disable user input till the actions are done playing
      disableUserInput: _props.accommodations.blockUserInteractions,
      onBeforeNextPageError: null,
      showSkippedQuestions: false
    };
    return _this;
  }
  _createClass(PlayerCore, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        flow: null
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this._setPageStartedTime();

      // Stop talking if the assistant was talking from previous page
      this.props.setParameters({
        isTalking: false
      });

      // Run actions
      this.timeout = setTimeout(this._runActions, 200);

      // Mute audio for games
      this.adjustAudioForGames();
      this.scrollToTop();
      window.addEventListener('keydown', this.stopPlayingActions);
      window.addEventListener('mousedown', this.stopPlayingActions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.actions.length > prevProps.actions.length && this.timeout) {
        // If we have new action and we still have time to register action
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this._runActions, 200);
      }

      // Mute audio for games
      if (this.props.enableAudio !== prevProps.enableAudio) {
        this.adjustAudioForGames();
      }

      // Play feedback audio if we switched to the feedback mode
      if (this.props.isFeedbackMode && !prevProps.isFeedbackMode) {
        this.timeout = setTimeout(this._runActions, 200);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.props.resetActions();
      clearTimeout(this.timeout);
      clearTimeout(this.onBeforeNextPageErrorTimeout);
      window.removeEventListener('keydown', this.stopPlayingActions);
      window.removeEventListener('mousedown', this.stopPlayingActions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        isPreviewMode = _this$props6.isPreviewMode,
        allowCancelAudio = _this$props6.allowCancelAudio,
        isCompleteMessage = _this$props6.isCompleteMessage,
        settings = _this$props6.settings,
        playerTemplate = _this$props6.playerTemplate;
      if ((0, _isEmpty2["default"])(settings)) {
        return null;
      }
      var customTemplate = (0, _allTemplates.getTemplate)('players', 'flow', playerTemplate.playerTemplate);
      if (!customTemplate) {
        throw new Error("There is no template \"".concat(playerTemplate.playerTemplate, "\""));
      }
      var Template = customTemplate.component;
      var actualPlayerSettings = this._getActualPlayerSettings();
      var templateProps = {
        flowId: this.props.flowId,
        isPreview: isPreviewMode,
        settings: settings,
        progressBar: this._renderProgressBar(actualPlayerSettings),
        isCompleteMessage: isCompleteMessage,
        prevButton: this._renderPrevButton(),
        nextButton: this._renderNextButton(),
        completeButton: this._renderCompleteButton(),
        completeMessage: this._renderCompleteMessage(),
        pubSub: this._getPubSub(),
        pages: this.props.getPagesForBlock(playerTemplate.parentId),
        parentsPages: this.props.getParentsPages(playerTemplate.parentId),
        playerTemplateSettings: actualPlayerSettings,
        templateSettings: actualPlayerSettings,
        // Advanced props
        showPrevButton: this._showPrevButton(),
        onPrevButtonClick: this._goToPrevPage,
        showNextButton: this._showNextButton(),
        onNextButtonClick: this._goToNextPage,
        showCompleteButton: this._showCompleteButton(),
        onCompleteButtonClick: this._goToNextPage,
        showFeedbackButton: this._showFeedbackButton(),
        onCorrectPreviousAnswers: this._correctPreviousAnswers,
        progressBarPercent: this.props.progressBarPercent,
        isErrorOnThePage: this.props.isErrorOnThePage,
        registerAction: this._registerAction.bind(this, 0),
        accommodations: this._getAdjustedAccommodations(this.props.accommodations),
        setParameters: this.props.setParameters,
        parameters: this.props.parameters,
        pawnId: this.props.pawnId,
        pawnHash: this.props.pawnHash,
        playingActions: this.props.playingAction.map(function (action) {
          return action.name;
        }),
        storage: this.props.storage,
        setToStorage: this.props.setToStorage,
        pageFirstElementId: this.props.pageFirstElementId,
        bubbleMessages: this.props.bubbleMessages,
        enableAudio: this.props.enableAudio,
        setEnableAudio: this.props.setEnableAudio,
        onBeforeNextPageError: this.state.onBeforeNextPageError,
        goBack: this.props.goBack,
        isMobilePageDescriptionVisible: this.props.isMobilePageDescriptionVisible,
        showBottomBar: this.props.showBottomBar,
        fullscreenToggle: this.props.fullscreenToggle,
        isFullscreen: this.props.isFullscreen,
        canFullscreen: this.props.canFullscreen,
        allowScaling: this.props.allowScaling
      };
      templateProps.elementBlock = this._renderElements(templateProps);
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.props.waitingForAjax
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(_ref8) {
          _this2.flowTop = _ref8;
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          if (!allowCancelAudio) {
            return;
          }

          // stop all sounds on click
          (0, _cccisdSound.stopAllDelayed)();
        },
        className: (0, _classnames3["default"])(_style["default"].player, _defineProperty({}, _style["default"].disableWrapper, this.state.disableUserInput))
      }, /*#__PURE__*/_react["default"].createElement(Template, templateProps)));
    }
  }]);
  return PlayerCore;
}(_react["default"].Component);
_defineProperty(PlayerCore, "propTypes", {
  flowId: _propTypes["default"].number,
  responseSet: _propTypes["default"].number,
  isCompleteMessage: _propTypes["default"].bool,
  answers: _propTypes["default"].object,
  errors: _propTypes["default"].object,
  settings: _propTypes["default"].object,
  updateAnswer: _propTypes["default"].func,
  setAnswerError: _propTypes["default"].func,
  showValidationErrors: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  pageFirstElementId: _propTypes["default"].number,
  setValidationErrors: _propTypes["default"].func,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  isEmptyPageHistory: _propTypes["default"].bool,
  isFirstPage: _propTypes["default"].bool,
  isLastPage: _propTypes["default"].bool,
  isErrorOnThePage: _propTypes["default"].bool,
  pageElements: _propTypes["default"].array,
  progressBarPercent: _propTypes["default"].number,
  getPagesForBlock: _propTypes["default"].func,
  getParentsPages: _propTypes["default"].func,
  isPreviewMode: _propTypes["default"].bool,
  actions: _propTypes["default"].array,
  playerTemplate: _propTypes["default"].object,
  parameters: _propTypes["default"].object,
  accommodations: _propTypes["default"].object,
  onComplete: _propTypes["default"].func,
  list: _propTypes["default"].object,
  progress: _propTypes["default"].object,
  setPageStartedTime: _propTypes["default"].func,
  storage: _propTypes["default"].object,
  setToStorage: _propTypes["default"].func,
  addSubscription: _propTypes["default"].func,
  deleteSubscription: _propTypes["default"].func,
  setPlayingAction: _propTypes["default"].func,
  unsetPlayingAction: _propTypes["default"].func,
  saveAndGoToNextPage: _propTypes["default"].func,
  saveAndGoToPrevPage: _propTypes["default"].func,
  saveAndGoToComponent: _propTypes["default"].func,
  saveStateAndMetrics: _propTypes["default"].func,
  subscriptions: _propTypes["default"].object,
  pawnId: _propTypes["default"].number,
  pawnHash: _propTypes["default"].string,
  playingAction: _propTypes["default"].array,
  allQuestionStartNumbers: _propTypes["default"].object,
  waitingForAjax: _propTypes["default"].bool,
  bubbleMessages: _propTypes["default"].array,
  dynamicUserLists: _propTypes["default"].array,
  dynamicUserListsValues: _propTypes["default"].object,
  enableAudio: _propTypes["default"].bool,
  setEnableAudio: _propTypes["default"].func,
  resetActions: _propTypes["default"].func,
  defaultValueVariables: _propTypes["default"].object,
  isFeedbackMode: _propTypes["default"].bool,
  hasPageFeedback: _propTypes["default"].bool,
  switchFeedbackMode: _propTypes["default"].func,
  forcedContextPlayerSettings: _propTypes["default"].object,
  contextPlayerSettings: _propTypes["default"].object,
  goBack: _propTypes["default"].func,
  isPageVisited: _propTypes["default"].bool,
  segmentedProgressBar: _propTypes["default"].array,
  isPresenterMode: _propTypes["default"].bool,
  allowCancelAudio: _propTypes["default"].bool,
  allowScaling: _propTypes["default"].bool
});
_defineProperty(PlayerCore, "defaultProps", {
  settings: {},
  answers: {},
  isPreviewMode: false,
  playingAction: [],
  defaultValueVariables: {}
});
_defineProperty(PlayerCore, "childContextTypes", {
  flow: _propTypes["default"].object
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    isCompleteMessage: state.flow.player.isCompleteMessage,
    answers: state.flow.player.answers,
    errors: state.flow.player.errors,
    settings: state.flow.player.settings,
    showValidationErrors: state.flow.player.showValidationErrors,
    pageFirstElementId: state.flow.player.pageFirstElementId,
    pageElements: (0, _player2.getPageElements)(state.flow.player),
    progressBarPercent: (0, _player2.getProgressBarPercent)(state.flow.player),
    getPagesForBlock: (0, _helpers.getPagesForBlock)(state.flow.player),
    getParentsPages: (0, _helpers.getParentsPages)(state.flow.player),
    isEmptyPageHistory: !state.flow.player.pageHistory || state.flow.player.pageHistory.length === 0,
    isFirstPage: (0, _player2.isFirstPage)(state.flow.player),
    isLastPage: (0, _player2.isLastPage)(state.flow.player),
    isErrorOnThePage: (0, _player2.isErrorOnThePage)(state.flow.player),
    playerTemplate: (0, _player2.getPlayerTemplate)(state.flow.player),
    actions: state.flow.player.actions,
    parameters: state.flow.player.parameters,
    accommodations: (0, _player2.getComposedAccommodations)(state.flow.player),
    list: state.flow.player.list,
    progress: state.flow.player.progress,
    storage: state.flow.player.storage,
    subscriptions: state.flow.player.subscriptions,
    playingAction: state.flow.player.playingAction,
    pawnId: state.flow.player.pawnId,
    pawnHash: state.flow.player.pawnHash,
    allQuestionStartNumbers: (0, _player2.getAllQuestionStartNumbers)(state.flow.player),
    waitingForAjax: state.flow.player.waitingForAjax,
    dynamicUserLists: state.flow.builder.dynamicUserLists,
    dynamicUserListsValues: props.userLists || (0, _builder.getFakeDynamicUserListsValues)(state.flow.builder),
    enableAudio: state.flow.player.enableAudio,
    bubbleMessages: (0, _player2.getBubbleMessages)(state.flow.player),
    isFeedbackMode: state.flow.player.isFeedbackMode,
    hasPageFeedback: (0, _player2.getHasPageFeedback)(state.flow.player),
    isAudioOnLoad: (0, _player2.getIsAudioOnLoad)(state.flow.player),
    isPageVisited: (0, _player2.getIsPageVisited)(state.flow.player),
    isMobilePageDescriptionVisible: (0, _player2.getIsMobilePageDescriptionVisible)(state.flow.player),
    segmentedProgressBar: (0, _player2.getSegmentedProgressBar)(state.flow.player),
    showBottomBar: (0, _player2.getShowBottomBar)(state.flow.player),
    isSkipped: (0, _player2.getIsSkipped)(state.flow.player),
    skippedElements: (0, _player2.getSkippedElements)(state.flow.player),
    isPresenterMode: state.flow.player.isPresenterMode,
    allowCancelAudio: (0, _player2.getAllowCancelAudio)(state.flow.player),
    allowScaling: (0, _player2.getAllowScaling)(state.flow.player)
  };
};
var Preloaded = (0, _preload["default"])()((0, _withContext["default"])({
  context: _context9.ForcedPlayerSettingsContext,
  propName: 'forcedContextPlayerSettings'
})((0, _withContext["default"])({
  context: _context9.DefaultPlayerSettingsContext,
  propName: 'contextPlayerSettings'
})((0, _reactRedux.connect)(mapStateToProps, {
  updateAnswer: _player.updateAnswer,
  setAnswerError: _player.setAnswerError,
  setValidationErrors: _player.setValidationErrors,
  registerAction: _player.registerAction,
  setParameters: _player.setParameters,
  setPageStartedTime: _player.setPageStartedTime,
  setToStorage: _player.setToStorage,
  addSubscription: _player.addSubscription,
  deleteSubscription: _player.deleteSubscription,
  setPlayingAction: _player.setPlayingAction,
  unsetPlayingAction: _player.unsetPlayingAction,
  saveAndGoToNextPage: _player.saveAndGoToNextPage,
  saveAndGoToPrevPage: _player.saveAndGoToPrevPage,
  saveAndGoToComponent: _player.saveAndGoToComponent,
  saveStateAndMetrics: _player.saveStateAndMetrics,
  setEnableAudio: _player.setEnableAudio,
  resetActions: _player.resetActions,
  switchFeedbackMode: _player.switchFeedbackMode
})((0, _ensureGlobalClick["default"])({
  hidePlayButton: function hidePlayButton(props) {
    return !props.isAudioOnLoad;
  }
})(PlayerCore)))));
var WithFullscreen = function WithFullscreen(props) {
  var _useFullscreen = (0, _useFullscreen2["default"])(),
    ref = _useFullscreen.ref,
    toggle = _useFullscreen.toggle,
    fullscreen = _useFullscreen.fullscreen,
    canFullscreen = _useFullscreen.canFullscreen;
  var fullscreenRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref(fullscreenRef.current);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: fullscreenRef,
    id: "cccisd-flow-fullscreen-element"
  }, /*#__PURE__*/_react["default"].createElement(Preloaded, _extends({
    fullscreenToggle: toggle,
    isFullscreen: fullscreen,
    canFullscreen: canFullscreen
  }, props)));
};
var _default = exports["default"] = WithFullscreen;